import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn, stringToSlug } from '@/lib/utils'
import { TMenuMobileSectionItem } from '@/types/header'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

type Props = {
  title: string
  list: TMenuMobileSectionItem[]
}

export const MobileNavList: React.FC<Props> = ({ title, list }) => {
  const t = useTranslations('header')
  return (
    <AccordionItem value={title} className='space-y-2 border-0'>
      <AccordionTrigger className='font-sans text-sm font-bold text-neutral-900 hover:no-underline'>
        {t(title)}
      </AccordionTrigger>
      <AccordionContent>
        {list.map((listItem) => (
          <Link
            href={listItem.href}
            aria-disabled={listItem.isComingSoon}
            tabIndex={listItem.isComingSoon ? -1 : 0}
            key={listItem.href}
            className={cn(
              'inline-block w-full rounded px-3 py-2 font-sans text-sm leading-5.5 text-neutral-600 hover:text-primary',
              listItem.img &&
                'flex items-center gap-2 border-b border-b-neutral-100',
              listItem.className,
              listItem.isComingSoon &&
                'pointer-events-none cursor-default text-neutral-400 hover:text-neutral-400'
            )}
            data-tracking-level-3={`_${stringToSlug(listItem.title)}`}
            onClick={(e) => listItem.isComingSoon && e.preventDefault()}
          >
            {listItem.img && (
              <Image
                src={ImageHelper.getImageUrl(listItem.img)}
                width={44}
                height={44}
                alt={listItem.title}
                className='rounded-full'
              />
            )}{' '}
            <p className={cn(listItem.img && 'flex-1 py-3')}>
              {t(listItem.title)}
              {listItem.subtitle && <i> {listItem.subtitle}</i>}
            </p>
          </Link>
        ))}
      </AccordionContent>
    </AccordionItem>
  )
}
